import { render, staticRenderFns } from "./DialogBossSchedule.vue?vue&type=template&id=20ba5abc&scoped=true&"
import script from "./DialogBossSchedule.vue?vue&type=script&lang=js&"
export * from "./DialogBossSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba5abc",
  null
  
)

export default component.exports